// import {
//   CriteriaWithPagination,
//   EuiBasicTable,
//   EuiBasicTableColumn,
//   EuiTableSelectionType,
//   Pagination,
// } from "@elastic/eui";
// import {
//   Title,
//   Card,
//   Badge,
//   Group,
//   Text,
//   ActionIcon,
//   Tooltip,
//   Box,
//   Stack,
// } from "@mantine/core";
// import { IconEdit, IconTrash, IconComponents } from "@tabler/icons-react";
// import { modals } from "@mantine/modals";
// import { useState, useEffect } from "react";
// import { NotificationExtension } from "../../_base/extension/NotificationExtension";
// import {
//   isNullOrEmpty,
//   isNullOrUndefined,
//   isNullOrUndefinedArry,
// } from "../../_base/extension/StringExtension";
// import Repository from "../../_base/helper/HttpHelper";
// import { paginationBase } from "../../_base/model/_base/BaseTable";
// import AppAction from "../../common/AppAction";
// import { API_ROUTE } from "../../const/apiRoute";
// import { MessageResponse } from "../../model/MessageResponse";
// import { TblBuildPcCatRel } from "../../model/TblBuildPc";
// import ChooseItemRelView from "./ChooseItemView";
// import CreateView from "./CreateView";
// import DeleteView from "./DeleteView";

// const BuildPcAccessory = () => {
//   const columns: Array<EuiBasicTableColumn<any>> = [
//     {
//       field: "categoryId",
//       name: "Mã LK",
//       sortable: true,
//       truncateText: true,
//       width: "8%",
//       render: (categoryId: number) => (
//         <Box p="md">
//           <Badge
//             variant="light"
//             color="blue"
//             size="lg"
//             radius="md"
//             style={{ fontSize: "14px" }}
//           >
//             #{categoryId}
//           </Badge>
//         </Box>
//       ),
//     },
//     {
//       field: "categoryName",
//       name: "Linh kiện chính",
//       sortable: true,
//       truncateText: true,
//       width: "25%",
//       render: (categoryName: string, online: TblBuildPcCatRel) => (
//         <Box p="md">
//           <Group gap="sm" align="center">
//             <IconComponents size={20} color="#228be6" />
//             <Text
//               size="md"
//               fw={500}
//               c="blue"
//               style={{ cursor: "pointer", fontSize: "15px" }}
//               onClick={() => handleEditData(online)}
//             >
//               {categoryName}
//             </Text>
//           </Group>
//         </Box>
//       ),
//     },
//     {
//       field: "categoryRelId",
//       name: "Mã LK liên quan",
//       sortable: true,
//       truncateText: true,
//       width: "10%",
//       render: (categoryRelId: number) => (
//         <Box p="md">
//           <Badge
//             variant="outline"
//             color="gray"
//             size="lg"
//             radius="md"
//             style={{ fontSize: "14px" }}
//           >
//             #{categoryRelId}
//           </Badge>
//         </Box>
//       ),
//     },
//     {
//       field: "categoryRelName",
//       name: "Linh kiện liên quan",
//       sortable: true,
//       truncateText: true,
//       width: "25%",
//       render: (categoryRelName: string) => (
//         <Box p="md">
//           <Text size="md" c="dark" style={{ fontSize: "15px" }}>
//             {categoryRelName}
//           </Text>
//         </Box>
//       ),
//     },
//     {
//       field: "productCount",
//       name: "Số sản phẩm",
//       sortable: true,
//       truncateText: true,
//       width: "12%",
//       render: (productCount: number) => (
//         <Box p="md">
//           <Badge
//             variant="filled"
//             color="green"
//             size="lg"
//             radius="md"
//             style={{ fontSize: "14px" }}
//           >
//             {productCount || 0} SP
//           </Badge>
//         </Box>
//       ),
//     },
//     {
//       name: "Thao tác",
//       width: "10%",
//       render: (online: any) => {
//         return (
//           <Box p="md">
//             <Group gap="sm" justify="center">
//               <Tooltip label="Chỉnh sửa" position="top">
//                 <ActionIcon
//                   variant="light"
//                   color="blue"
//                   size="md"
//                   radius="md"
//                   onClick={() => {
//                     if (isNullOrUndefined(online))
//                       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//                     else {
//                       editItem(online);
//                     }
//                   }}
//                 >
//                   <IconEdit size={18} />
//                 </ActionIcon>
//               </Tooltip>
//               {/* <Tooltip label="Xóa" position="top">
//                 <ActionIcon
//                   variant="light"
//                   color="red"
//                   size="md"
//                   radius="md"
//                   onClick={() => {
//                     if (isNullOrUndefined(online))
//                       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//                     else {
//                       deleteItem([online.id]);
//                     }
//                   }}
//                 >
//                   <IconTrash size={18} />
//                 </ActionIcon>
//               </Tooltip> */}
//             </Group>
//           </Box>
//         );
//       },
//     },
//   ];
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | undefined>();
//   const [pagination, setPagination] = useState<Pagination>(paginationBase);
//   const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
//   const [datas, setDatas] = useState<TblBuildPcCatRel[]>([]);

//   const handleEditData = async (item: TblBuildPcCatRel) => {
//     if (item) {
//       editItem(item);
//     } else {
//       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//     }
//   };
//   const onTableChange = async ({
//     page: { index, size },
//   }: CriteriaWithPagination<any>) => {
//     setPagination({
//       ...pagination,
//       pageIndex: index,
//       pageSize: size,
//       totalItemCount: 1000,
//     });
//   };

//   const onSelectionChange = (selectedItems: any[]) => {
//     setSelectedItems(selectedItems);
//   };
//   const selection: EuiTableSelectionType<any> = {
//     selectable: (user: any) => true,
//     selectableMessage: (selectable: boolean) =>
//       !selectable ? "User is currently offline" : "",
//     onSelectionChange,
//   };

//   const openModal = () =>
//     modals.openConfirmModal({
//       title: (
//         <>
//           <div color="white">
//             <Title order={5}>Thêm mới danh mục liên quan</Title>
//           </div>
//         </>
//       ),
//       children: (
//         <CreateView
//           onSearch={() =>
//             fetchDataCategoryRel(pagination.pageIndex, pagination.pageSize)
//           }
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });

//   const openModalEdit = () => {
//     if (
//       isSelectedItem &&
//       (isSelectedItem.length < 1 || isSelectedItem.length > 1)
//     )
//       NotificationExtension.Warn("Xin vui lòng chọn 1 danh mục để chỉnh sửa !");
//     else {
//       editItem(isSelectedItem[0]);
//     }
//   };

//   const openModalDelete = () => {
//     if (isSelectedItem && isSelectedItem.length < 1)
//       NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
//     else {
//       const ids = isSelectedItem;
//       deleteItem(ids.map((item) => item?.id));
//     }
//   };

//   function deleteItem(idItem: number[]) {
//     modals.openConfirmModal({
//       title: (
//         <>
//           <Title order={5}>Xóa danh mục</Title>
//         </>
//       ),
//       children: (
//         <DeleteView
//           onSearch={() =>
//             fetchDataCategoryRel(pagination.pageIndex, pagination.pageSize)
//           }
//           idItem={idItem}
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   }

//   function editItem(category: TblBuildPcCatRel) {
//     const dataCategory = {
//       categoryId: category.categoryId,
//       categoryName: category.categoryName,
//       relCategoryId: category.categoryRelId,
//       relCategoryName: category.categoryRelName,
//     };
//     modals.openConfirmModal({
//       title: (
//         <>
//           <Title order={5}>Chỉnh sửa danh mục!</Title>
//         </>
//       ),
//       children: (
//         <ChooseItemRelView
//           dataCategory={dataCategory}
//           //   onSearch={() =>
//           //     fetchDataCategoryRel(
//           //       pagination.pageIndex,
//           //       pagination.pageSize,
//           //       paramSearch?.keyWord,
//           //       paramSearch?.inActive
//           //     )
//           //   }
//         />
//       ),
//       confirmProps: { display: "none" },
//       cancelProps: { display: "none" },
//     });
//   }

//   const fetchDataCategoryRel = async (
//     index: number,
//     size?: number,
//     keyWord?: string,
//     inActive?: boolean
//   ) => {
//     setLoading(true);
//     setDatas([]);
//     setError(undefined);
//     const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
//     try {
//       let urlSearch = `${API_ROUTE.GET_LIST_CAT_BUILD}?Skip=${
//         index * (size ?? 0)
//       }&Take=${size}`;
//       if (!isNullOrEmpty(keyWord))
//         urlSearch = urlSearch + `&KeySearch=` + keyWord;
//       if (!isNullOrUndefined(inActive))
//         urlSearch = urlSearch + `&Active=` + inActive;
//       let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
//       if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
//         // setTotal(0); // Removed since total is not used
//       } else {
//         setDatas(callapi?.data ?? []);
//         setPagination({
//           ...pagination,
//           totalItemCount: callapi?.totalCount ?? 0,
//         });
//         // setTotal(callapi?.totalCount ?? 0); // Removed since total is not used
//       }
//       return callapi?.data;
//     } catch (error: any) {
//       setError("Có lỗi xảy ra khi tải dữ liệu !");
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     const fetchData = async () => {
//       await fetchDataCategoryRel(pagination.pageIndex, pagination.pageSize);
//     };
//     fetchData();
//   }, []);
//   return (
//     <Stack gap="xl" style={{ minHeight: "100vh", padding: "20px" }}>
//       <Card
//         shadow="md"
//         p="xl"
//         radius="lg"
//         withBorder
//         style={{ minHeight: "120px" }}
//       >
//         <Stack gap="xl">
//           <Group gap="md" align="center">
//             <IconComponents size={32} color="#228be6" />
//             <Title order={2} c="blue" size="28px">
//               Quản lý linh kiện Build PC
//             </Title>
//           </Group>
//           {/* <Group justify="flex-start" align="center">
//             <AppAction
//               // openModal={openModal}
//               openModalDelete={openModalDelete}
//               openModalEdit={openModalEdit}
//             />
//           </Group> */}
//         </Stack>
//       </Card>
//       <Card
//         shadow="md"
//         p="xl"
//         radius="lg"
//         withBorder
//         style={{ minHeight: "600px" }}
//       >
//         <EuiBasicTable
//           tableCaption="Bảng quản lý linh kiện Build PC"
//           items={datas ? datas : []}
//           itemId="id"
//           error={error}
//           loading={loading}
//           noItemsMessage={"Không có dữ liệu"}
//           selection={selection}
//           columns={columns}
//           pagination={pagination}
//           isSelectable={true}
//           hasActions={true}
//           responsive={true}
//           onChange={onTableChange}
//           compressed={false}
//           tableLayout="auto"
//         />
//       </Card>
//     </Stack>
//   );
// };

// export default BuildPcAccessory;

import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Menu,
  rem,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { IconPlus, IconSearch, IconTrash, IconX } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "@mantine/form";
import { _localization } from "../../config/location";
import BreadCrumb from "../../_base/component/_layout/_breadcrumb";
import axios from "axios";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { MessageResponse } from "../../model/MessageResponse";
import { IconEdit } from "@tabler/icons-react";
import { API_ROUTE } from "../../const/apiRoute";
import Repository from "../../_base/helper/HttpHelper";
import { TblBuildPcCatRel } from "../../model/TblBuildPc";
import DeleteView from "./DeleteView";
import ChooseItemRelView from "./ChooseItemView";
import CreateView from "./CreateView";
import { useLocation } from "react-router-dom";

interface SearchCriteria {
  keySearch?: string;
  status?: string;
}
const BuildPcAccessory = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [searchKeyword, setSearchKeyword] = useState(
    _searchJson && checkedPinSearch ? _searchJson?.searchKeyword : ""
  );
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  const styleTableMantine = {
    fontWeight: "500",
  };
  const filteredData = useMemo(() => {
    if (!searchKeyword.trim()) return data;

    return data.filter((item) =>
      item.categoryName.toLowerCase().includes(searchKeyword.toLowerCase())
    );
  }, [data, searchKeyword]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "categoryId",
        header: "Mã linh kiện",
        size: 135,
        Cell: ({ row }) => (
          <Box p="md">
            <Badge
              variant="light"
              color="blue"
              size="lg"
              radius="md"
              style={{ fontSize: "14px" }}
            >
              #{row.original.categoryId}
            </Badge>
          </Box>
        ),
      },
      {
        accessorKey: "categoryName",
        header: "Linh kiện chính",
        size: 250,
        Cell: ({ row }) => (
          <Box p="md">
            <Group gap="sm" align="center">
              <Text size="md" fw={500} c="blue" style={{ fontSize: "14px" }}>
                {row.original.categoryName}
              </Text>
            </Group>
          </Box>
        ),
      },
      {
        accessorKey: "categoryRelId",
        header: "Mã LK liên quan",
        size: 135,
        Cell: ({ row }) => (
          <Box p="md">
            <Badge
              variant="outline"
              color="gray"
              size="lg"
              radius="md"
              style={{ fontSize: "14px" }}
            >
              #{row.original.categoryRelId}
            </Badge>
          </Box>
        ),
      },
      {
        accessorKey: "categoryRelName",
        header: "Linh kiện liên quan",
        size: 250,
        Cell: ({ row }) => (
          <Box p="md">
            <Text size="md" c="dark" style={{ fontSize: "15px" }}>
              {row.original.categoryRelName}
            </Text>
          </Box>
        ),
      },
      {
        accessorKey: "productCount",
        header: "Số sản phẩm",
        size: 250,
        Cell: ({ row }) => (
          <Box p="md">
            <Badge
              variant="filled"
              color="green"
              size="lg"
              radius="md"
              style={{ fontSize: "14px" }}
            >
              {row.original.productCount || 0} SP
            </Badge>
          </Box>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() => editItem(row.original)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }

      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${API_ROUTE.GET_LIST_CAT_BUILD}?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới danh mục liên quan</Title>
          </div>
        </>
      ),
      children: <CreateView onSearch={() => fetchData()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  // const openModalEdit = () => {
  //   if (
  //     isSelectedItem &&
  //     (isSelectedItem.length < 1 || isSelectedItem.length > 1)
  //   )
  //     NotificationExtension.Warn("Xin vui lòng chọn 1 danh mục để chỉnh sửa !");
  //   else {
  //     editItem(isSelectedItem[0]);
  //   }
  // };

  // const openModalDelete = () => {
  //   if (isSelectedItem && isSelectedItem.length < 1)
  //     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //   else {
  //     const ids = isSelectedItem;
  //     deleteItem(ids.map((item) => item?.id));
  //   }
  // };
  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa danh mục</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(category: TblBuildPcCatRel) {
    const dataCategory = {
      categoryId: category.categoryId,
      categoryName: category.categoryName,
      relCategoryId: category.categoryRelId,
      relCategoryName: category.categoryRelName,
    };
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa danh mục!</Title>
        </>
      ),
      children: (
        <ChooseItemRelView
          dataCategory={dataCategory}
          //   onSearch={() =>
          //     fetchDataCategoryRel(
          //       pagination.pageIndex,
          //       pagination.pageSize,
          //       paramSearch?.keyWord,
          //       paramSearch?.inActive
          //     )
          //   }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
    });
  }

  const table = useMantineReactTable({
    columns,
    data: filteredData,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.invoiceId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
  }, [pagination]);
  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                value={searchKeyword}
                onChange={(e) => {
                  setSearchKeyword(e.currentTarget.value);
                  sessionStorage.setItem(
                    String(location.pathname),
                    JSON.stringify({ searchKeyword: e.currentTarget.value })
                  );
                }}
              />
            </Grid.Col>
          </Grid>
          {/* <Group>
            <Button
              mt={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                openModal();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteItem(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group> */}
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default BuildPcAccessory;
